import React, { Component } from 'react'
import Button from './Button'
import { Link } from 'react-router-dom'
import Card from './Card'

class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: undefined }
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch (error, info) {
    console.error('Caught an error:', error, info)
  }

  render () {
    if (this.state.hasError) {
      return (
        <div
          display='grid'
          style={{
            display: 'grid',
            placeItems: 'center',
            height: '100dvh',
            overflow: 'auto',
            gap: 5,
            paddingTop: 5,
            paddingBottom: 5
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
              alignItems: 'center'
            }}
          >
            <h5>Oops! Something went wrong...</h5>
            <Card>
              <p>
                If you were in the middle of a Session, The teacher should
                contact support with the session ID to recover data.
              </p>
            </Card>
            <p>{this.state.error?.message || 'Unkown Error'}</p>
            <Link to='/'>
              <Button
                fillBackground
                onClick={() => {
                  this.setState({ hasError: false, error: undefined })
                }}
              >
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
